export const ANALYTICS = {
    CTA_CLICK_EVENT: "CREATOR_MARKETPLACE_UPSELL_CTA",
};

export const NA = "N/A";

export const DASH = "-";

export const DEFAULT_LOCALE = "en-US";

export const SUBSCRIPTION_EMAIL = "camkit-previews-external@snapchat.com";
